import { render, staticRenderFns } from "./OrderProducts.vue?vue&type=template&id=6c83eb75"
import script from "./OrderProducts.vue?vue&type=script&lang=js"
export * from "./OrderProducts.vue?vue&type=script&lang=js"
import style0 from "./OrderProducts.vue?vue&type=style&index=0&id=6c83eb75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports